import { useEffect, useState } from "react";
import { backend_url } from "../App";

// Text/images for a website section, editable from the admin panel.
// Starts with the built-in `defaults` (or this browser's last saved copy) and
// fills in the saved version; any field left empty keeps its built-in value.
const merge = (defaults, saved) => {
  const out = { ...defaults };
  Object.entries(saved || {}).forEach(([k, v]) => {
    if (!(k in defaults)) return;
    if (typeof v === "boolean") { out[k] = v; return; } // on/off switches
    if (Array.isArray(v) ? v.length : typeof v === "string" && v.trim()) out[k] = v;
  });
  return out;
};

const useSiteContent = (key, defaults) => {
  const cacheKey = `siteContent:${key}`;
  const [content, setContent] = useState(() => {
    try { return merge(defaults, JSON.parse(localStorage.getItem(cacheKey))); } catch { return defaults; }
  });

  useEffect(() => {
    let cancelled = false;
    fetch(`${backend_url}/api/site-content/${key}`)
      .then((r) => r.json())
      .then((res) => {
        if (cancelled || !res.success) return;
        setContent(merge(defaults, res.data));
        try {
          if (res.data) localStorage.setItem(cacheKey, JSON.stringify(res.data));
          else localStorage.removeItem(cacheKey);
        } catch { /* ignore */ }
      })
      .catch(() => { /* keep built-in text */ });
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key]);

  return content;
};

export default useSiteContent;
